<template>
  <q-btn
    icon="fa fa-cog"
    title="Manage Integration"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { IntegrationConnection } from '@/iam/types';
import ManageModal from './ManageModal.vue';

export default defineComponent({
  emits: ['update:connection'],
  props: {
    connection: {
      type: Object as () => IntegrationConnection,
      required: true,
    },
  },
  methods: {
    openModal(): void {
      const config = { parent: this, connection: this.connection };
      openModal(ManageModal, config).onOk((connection: IntegrationConnection) => {
        this.$emit('update:connection', connection);
      });
    },
  },
});
</script>
